import React from 'react';
import useStyles from './Graph.style';
import { Grid, Box } from '@material-ui/core';

const ServiceTypeTransfer: React.FC<{ data: Record<string, any> }> = ({ data }) => {
  const hasData = data && Object.keys(data).length > 0;
  const classes = useStyles();
  return (
    <div className="card-wrapper">
        <Box className={classes.headerWrapper} display="flex" justifyContent="space-between" alignItems="center">
          <Grid item className={classes.chartTitle}>
              Data Transfer Costs by Service & Type
          </Grid>
        </Box>
        <div className="parent-container">
        
          {hasData ? (
            <div className="chart-placeholder">[Chart Here]</div>
          ) : (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
              No data available
          </div>
          )}
        </div>
    </div>
  );
};

export default ServiceTypeTransfer;